import { render, staticRenderFns } from "./TestMethod.vue?vue&type=template&id=d2272814"
import script from "./TestMethod.vue?vue&type=script&lang=js"
export * from "./TestMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports